//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('root/Assets/Js/Templates',[
	'root/Assets/Templates/Html/AlaCarte/Js/AlaCarte',
	'root/Assets/Templates/Html/CookingClass/Js/CookingClass',
	'root/Assets/Templates/Html/FullFooter/Js/FullFooter',
	'root/Assets/Templates/Html/FullwidthSlider/Js/FullwidthSlider',
	'root/Assets/Templates/Html/HashtagTeaser/Js/HashtagTeaser',
	'root/Assets/Templates/Html/ImageSlider/Js/ImageSlider',
	'root/Assets/Templates/Html/IntroSlideAnimation/Js/IntroSlideAnimation',
	'root/Assets/Templates/Html/Menus/Js/Menus',
	'root/Assets/Templates/Html/NewsletterBox/Js/NewsletterBox',
	'root/Assets/Templates/Html/TeaserSlider/Js/TeaserSlider',
	'root/Assets/Templates/Html/schnitzelface/Js/schnitzelface',
	'root/Assets/Templates/Html/schnitzlqualitaet/Js/schnitzlqualitaet'
], function () {
	return arguments;
});

